import { Container } from "react-bootstrap";

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import SwiperCore, { Pagination, Autoplay, Navigation } from "swiper";
SwiperCore.use([Pagination, Autoplay, Navigation]);

import { useIntl } from "react-intl";
import Licen from "./Licen";
import SectionHead from "../Shared/SectionHead";

const Licens = ({ licensData }) => {
  const { locale, formatMessage } = useIntl();
  const dir = locale === "ar" ? "rtl" : "ltr";

  const allLicens = licensData?.licensData;

  const renderTeamMembers = allLicens?.map((item, index) => {
    return (
      <SwiperSlide key={index}>
        <Licen licen={{ ...item, id: index + 1 }} />
      </SwiperSlide>
    );
  });

  return (
    <>
      <div className="licens">
        <Container>
          <SectionHead
            subtitle={formatMessage({ id: "whyUs" })}
            title={licensData?.sectionTitle?.[locale]}
          />

          <div className="teamMembers-slider">
            <Swiper
              key={dir}
              dir={dir}
              loop={false}
              slidesPerView={3}
              spaceBetween={30}
              grabCursor={true}
              // navigation={true}
              modules={[Pagination]}
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
              breakpoints={{
                320: {
                  slidesPerView: 1.5,
                  centeredSlides: true,
                  spaceBetween: 15,
                },
                640: {
                  slidesPerView: 2,
                },
                991: {
                  slidesPerView: 3,
                },
                1024: {
                  slidesPerView: 3,
                },
                2400: {
                  slidesPerView: 3,
                },
              }}
              autoplay={{
                delay: 2500,
                disableOnInteraction: false,
              }}
              className="mySwiper"
            >
              {renderTeamMembers}
            </Swiper>
          </div>
        </Container>
      </div>
    </>
  );
};

export default Licens;
